import React from 'react'
import './UnrecoverableError.css'

const UnrecoverableErrorUI = ({context, unrecoverableError}) =>
  <div className='com_u_error g_flex_v'>
    <div className='content'>
      {unrecoverableError}
    </div>
  </div>

export default UnrecoverableErrorUI
